import courierFileDetailEs from './es/courier-file-detail.json';
import courierFileDetailEn from './en/courier-file-detail.json';

export const codCourierFileDetailEs = courierFileDetailEs;
export const codCourierFileDetailEn = courierFileDetailEn;
